export default __webpack_public_path__ + "static/media/1313.b09789e1.png";